/**
 * @fileoverview POST handler for the "/engagement/campaigns_data_filters" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementCampaignsDataFiltersCacheKeys } from "./constants";
import type { PostEngagementCampaignsDataFiltersProps, EngagementCampaignsDataFiltersResult } from "./types";

export const postEngagementCampaignsDataFilters = reactQueryMutationAdapter(
  engagementCampaignsDataFiltersCacheKeys,
  (props: PostEngagementCampaignsDataFiltersProps): Promise<EngagementCampaignsDataFiltersResult> => {
    return fetch("/engagement/campaigns_data_filters", "POST", props, undefined, {
      // don't display a modal on fetch errors
      propagateFetchRequestError: false,
    });
  }
);
